import { render, staticRenderFns } from "./HtmlBox.vue?vue&type=template&id=46db2324&"
import script from "./HtmlBox.vue?vue&type=script&lang=js&"
export * from "./HtmlBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports